import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Overline from "./Overline";
import { reveal, VIEW_80 } from "./motion";

export const AboutFounder = () => (
  <section data-testid="about-founder" className="px-6 py-28 md:px-16 lg:px-24">
    <motion.div
      variants={reveal}
      initial="hidden"
      whileInView="show"
      viewport={VIEW_80}
      className="grid items-center gap-12 lg:grid-cols-[auto_1fr] lg:gap-20"
    >
      <div className="relative mx-auto lg:mx-0">
        <div className="absolute inset-0 rounded-full bg-[#8B5CF6]/25 blur-[60px]" />
        <div className="relative flex h-48 w-48 items-center justify-center rounded-full border border-white/15 bg-[#12141C]/70 backdrop-blur-2xl md:h-64 md:w-64">
          <div className="absolute inset-3 rounded-full border border-[#06B6D4]/30 [animation:spin_24s_linear_infinite]" />
          <span className="font-display bg-gradient-to-br from-[#8B5CF6] via-[#7dd8ea] to-[#D4AF37] bg-clip-text text-6xl font-black tracking-tight text-transparent md:text-7xl">
            AK
          </span>
        </div>
      </div>
      <div>
        <Overline>The Founder</Overline>
        <h2
          data-testid="about-founder-name"
          className="font-display text-3xl font-bold leading-tight text-[#F4F6FB] md:text-4xl"
        >
          AK Padvnavam
        </h2>
        <p
          data-testid="about-founder-role"
          className="mt-3 font-mono text-[11px] uppercase tracking-[0.3em] text-[#06B6D4]"
        >
          Founder · Programmer &amp; Creative Technologist
        </p>
        <div className="mt-6 max-w-2xl space-y-5 text-sm leading-relaxed text-[#F4F6FB]/60 md:text-base">
          <p>
            Elentara was founded on a refusal: the web had settled for flat, forgettable pages
            when it could hold entire worlds. The studio is led personally by AK — a programmer
            who works at the seam of art and code — so every project carries one vision, one
            standard, one signature.
          </p>
          <p>
            Before the studio, AK spent his days as a SOC analyst at GitLab, watching systems
            under real pressure. Security work teaches a specific kind of discipline: read the
            whole system, trust nothing you haven't verified, and assume the edge case will
            arrive. That discipline now shows up as render budgets, graceful fallbacks, and
            interfaces that hold together on every device.
          </p>
          <p>
            The rest is craft. Shaders, motion curves, and typography are treated with the same
            rigour as an incident timeline — because imagination only becomes reality when the
            engineering refuses to compromise.
          </p>
        </div>
        <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
          "A website should be a place, not a page."
        </p>
        <a
          href="https://x.com/AKPADVANAVAM"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="about-founder-x-link"
          className="group mt-8 inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/5 px-6 py-3 font-mono text-[11px] uppercase tracking-[0.25em] text-[#F4F6FB]/75 backdrop-blur-xl transition-colors duration-300 hover:border-[#06B6D4]/60 hover:text-[#F4F6FB]"
        >
          @AKPADVANAVAM on X
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </a>
      </div>
    </motion.div>
  </section>
);

export default AboutFounder;
